import axios from "axios";
import { useQuery } from "react-query";

import { NonEligibleMaterialConfig } from "../types/domain";

const getNonEligibleMaterials = () =>
  axios
    .get<NonEligibleMaterialConfig[]>("materials/getNonEligibleMaterials")
    .then((res) => res.data);

const useNonEligibleMaterials = () =>
  useQuery("nonEligibleMaterials", getNonEligibleMaterials, {
    staleTime: Infinity,
  });

export default useNonEligibleMaterials;
